import React from 'react';

import { appEvents } from 'modules';
import { PaginatedTable } from 'modules/layer1/pagination';

import * as dataService from './dataService';



export interface IProps {
  onChangeLoading: (loading: boolean) => void;
}

export const FC: React.FC<IProps> = props => {
  const {
    data,
    refetch,
    loading,
    mutations
  } = dataService.useQuery();



  React.useEffect(() => {
    props.onChangeLoading(loading);
  }, [loading, props]);



  React.useEffect(() => {
    const sub = appEvents.observable().subscribe(event => {
      if (event?.type === 'modal' && event.args === 'close') {
        refetch();
      }
    });

    return () => {
      sub.unsubscribe();
    };
  }, [refetch]);



  return (
    <PaginatedTable.FC
      data={data.investmentAreas}
      rowActions={[
        {
          label: 'Edit investment area',
          fnAction: id => {
            appEvents.broadcast({
              type: 'modal',
              args: {
                type: 'editInvestmentArea',
                investmentAreaId: id
              }
            });
          }
        },
        {
          label: 'Remove investment area',
          fnAction: id => {
            appEvents.broadcast({
              type: 'modal',
              args: {
                type: 'confirm',
                title: 'Are You Sure?',
                body: 'Once you remove this investment area, it cannot be undone. Please make sure if you would like to go through with this.',
                onConfirm: async () => {
                  await mutations.deleteInvestmentArea(id);
                  refetch();
                }
              }
            });
          }
        }
      ]}
      columnDefs={[
        {
          label: 'Investment Area Name',
          fnRenderCell: row => row.displayName
        }
      ]} />
  );
};
